<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body p-3">
            <div class="card-title mb-2">
              <span>{{ $t("malware.create-report") }}</span>
            </div>
            <form-wizard
              ref="reportwizard"
              color="#1a3fa3"
              :hide-buttons="true"
              @on-change="changeTab"
            >
              <tab-content icon="bx bx-file-blank">
                <tab-1
                  :validations="tab1validations"
                  :idReport="id_report"
                  @id-report="setIdReport"
                  @validation-failed="invalidTab1"
                  @next-tab="nextTab"
                  @report-type="setReportType"
                ></tab-1>
                <div class="d-flex justify-content-end mt-3">
                  <b-button
                    variant="primary"
                    @click="validationTab1"
                    :disabled="loading.process"
                  >
                    {{ $t("malware.next") }}
                    <i
                      class="bx bx-chevron-right font-size-16 align-middle"
                    ></i>
                  </b-button>
                </div>
              </tab-content>
              <tab-content icon="bx bx-analyse">
                <tab-2
                  :validations="tab2validations"
                  :reportType="report_type"
                  :idReport="id_report"
                  @validation-failed="invalidTab2"
                  @next-tab="nextTab"
                ></tab-2>
                <div class="d-flex justify-content-between mt-3">
                  <b-button
                    variant="primary"
                    @click="prevTab"
                    :disabled="loading.process"
                  >
                    <i class="bx bx-chevron-left font-size-16 align-middle"></i>
                    {{ $t("malware.previous") }}
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="validationTab2"
                    :disabled="loading.process"
                  >
                    {{ $t("malware.next") }}
                    <i
                      class="bx bx-chevron-right font-size-16 align-middle"
                    ></i>
                  </b-button>
                </div>
              </tab-content>
              <tab-content icon="bx bx-detail" v-if="report_type != 'manual'">
                <tab-3
                  :validationsProcess="tab3validations"
                  :idReport="id_report"
                  @validation-failed="invalidTab3"
                  @next-tab="nextTab"
                ></tab-3>
                <div class="d-flex justify-content-between mt-3">
                  <b-button
                    variant="primary"
                    @click="prevTab"
                    :disabled="loading.process"
                  >
                    <i class="bx bx-chevron-left font-size-16 align-middle"></i>
                    {{ $t("malware.previous") }}
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="validationTab3"
                    :disabled="loading.process"
                  >
                    {{ $t("malware.next") }}
                    <i
                      class="bx bx-chevron-right font-size-16 align-middle"
                    ></i>
                  </b-button>
                </div>
              </tab-content>
              <tab-content icon="mdi mdi-checkbox-marked-circle-outline">
                <tab-4
                  :refreshSlider="refslider"
                  :validations="finishvalidation"
                  :idReport="id_report"
                  @validation-failed="invalidTab4"
                  @complete="onComplete"
                ></tab-4>
                <div class="d-flex justify-content-between mt-3">
                  <b-button
                    variant="primary"
                    @click="prevTab"
                    :disabled="loading.process"
                  >
                    <i class="bx bx-chevron-left font-size-16 align-middle"></i>
                    {{ $t("malware.previous") }}
                  </b-button>
                  <b-button
                    variant="primary"
                    @click="finishValidation"
                    :disabled="loading.process"
                  >
                    {{ $t("malware.finish") }}
                    <i class="bx bx-check-double font-size-16 align-middle"></i>
                  </b-button>
                </div>
              </tab-content>
            </form-wizard>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Layout from "../../layouts/main";
import Tab1 from "../malware/tab-wizard/tab1.vue";
import Tab2 from "../malware/tab-wizard/tab2.vue";
import Tab3 from "../malware/tab-wizard/tab3.vue";
import Tab4 from "./tab-wizard/tab4.vue";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import VueSlideBar from "vue-slide-bar";
import Vue from "vue";
import { projectData } from "./data-projects";

export default {
  page: {
    title: "Report",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    FormWizard,
    TabContent,
    Tab1,
    Tab2,
    Tab3,
    Tab4,
    VueSlideBar,
  },
  data() {
    return {
      projectData: projectData,
      title: "Report Analysis",
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: "Report Analysis",
          href: "/malware/report-analysis",
        },
        {
          text: "Create Report",
          active: true,
        },
      ],
      theme: localStorage.getItem("theme") ?? "light",
      simpleValue: 0,
      tags: [],
      detail: {},
      tab1validations: false,
      tab2validations: false,
      tab3validations: false,
      finishvalidation: false,
      refslider: false,
      report_type: "",
      id_report: "",
      loading: {
        process: false,
      },
    };
  },
  methods: {
    nextTab() {
      this.loading.process = false;
      this.$refs.reportwizard.nextTab();
    },
    prevTab() {
      this.$refs.reportwizard.prevTab();
    },
    onComplete() {
      Vue.swal({
        position: "top-end",
        icon: "success",
        title: "Success Create or Updated Report",
        showConfirmButton: false,
        timer: 1500,
      });
      this.$router.push("/malware/report-analysis");
    },
    validationTab1() {
      this.tab1validations = true;
      this.loading.process = true;
      setTimeout(() => {
        this.tab1validations = false;
      }, 1000);
    },
    invalidTab1() {
      this.loading.process = false;
      this.tab1validations = false;
    },
    validationTab2() {
      this.tab2validations = true;
      this.loading.process = true;
      setTimeout(() => {
        this.tab2validations = false;
      }, 1000);
    },
    invalidTab2() {
      this.loading.process = false;
      this.tab2validations = false;
    },
    validationTab3() {
      this.tab3validations = true;
      this.loading.process = true;
      setTimeout(() => {
        this.tab3validations = false;
      }, 1000);
    },
    invalidTab3() {
      this.loading.process = false;
      this.tab3validations = false;
    },
    finishValidation() {
      this.finishvalidation = true;
      this.loading.process = true;
      setTimeout(() => {
        this.finishvalidation = false;
      }, 1000);
    },
    invalidTab4() {
      this.loading.process = false;
      this.finishvalidation = false;
    },
    setReportType(val) {
      this.report_type = val;
    },
    setIdReport(val) {
      this.id_report = val;
    },
    changeTab(e) {
      if (this.report_type == "manual" && e == 1) {
        setTimeout(() => {
          this.refslider = true;
        }, 500);
        setTimeout(() => {
          this.refslider = false;
        }, 1000);
      }
      if (this.report_type == "auto" && e == 2) {
        setTimeout(() => {
          this.refslider = true;
        }, 500);
        setTimeout(() => {
          this.refslider = false;
        }, 1000);
      }
    },
    refreshSlider() {
      this.$refs.riskscore.refresh();
    },
    setId() {
      const id = this.$route.query.id;
      if (id) {
        this.id_report = Buffer.from(id, "base64").toString("ascii");
      }
    },
  },
  created() {
    this.setId();
  },
  mounted() {},
};
</script>
